import React, { useEffect, useState } from 'react';
import axios from 'axios';

import Input from './Input';
import Current from './Current.js';
import Forecast from './Forecast';

import './css/weather-icons.min.css';
import './css/App.css';
import './css/Icons.css';
import './css/Input.css';
import './css/Current.css';
import './css/Forecast.css';
import './css/Rwd.css';

const App = () => {
    const [initialLongitude, setInitialLongitude] = useState(0);
    const [initialLatidue, setInitialLatidue] = useState(0);
    const initialData = {
        coord: {
            lon: initialLongitude,
            lat: initialLatidue,
        },
    };
    const [data, setData] = useState(initialData);
    const [city, setCity] = useState();
    const [forecast, setForecast] = useState();
    const [userLocation, setUserLocation] = useState('');

    useEffect(() => {
        setTimeout(() => {
            if (initialLatidue !== 0 && initialLongitude !== 0) {
                document.querySelectorAll('.hide').forEach((section) => {
                    section.style.opacity = '1';
                    section.style.display = 'block';
                });
                document.querySelector('.current-forecast').style.display =
                    'flex';
            }
        }, 1500);
    }, [initialLatidue, initialLongitude]);

    const getCity = (e) => {
        setCity(e.target.value);
    };

    const getForecastData = (lat, lon) => {
        if (lat !== 0 && lon !== 0) {
            axios
                .get(
                    `https://api.openweathermap.org/data/2.5/onecall?lat=${lat}&lon=${lon}&exclude=hourly,current,minutely,alerts&appid=de310e87d3a7bcda1c723953103565a6&units=metric&lang=pl`
                )
                .then((res) => {
                    setForecast(res.data);
                })
                .catch((err) => {
                    console.warn(err);
                });
        }
    };

    const getCurrentData = (city) => {
        axios
            .get(
                `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=de310e87d3a7bcda1c723953103565a6&units=metric&lang=pl`
            )
            .then((res) => {
                //success
                setData(res.data);
                document.querySelector('.error-msg').textContent = '';
                document.querySelector('.input-wrap input').value = '';
            })
            .catch((err) => {
                if (initialLatidue && initialLongitude) {
                    if (document.querySelector('input').value === '') {
                        document.querySelector('.error-msg').textContent =
                            'Musisz podać nazwę miasta!';
                        console.warn(err);
                    } else {
                        document.querySelector('.error-msg').textContent =
                            'Wpisz poprawną nazwę miasta!';
                        console.warn(err);
                    }
                }
            });
    };

    useEffect(() => {
        const options = {
            enableHighAccuracy: true,
            timeout: 5000,
            maximumAge: 0,
        };
        function success(pos) {
            const crd = pos.coords;
            const geoApiUrl = `https://api.bigdatacloud.net/data/reverse-geocode?latitude=${crd.latitude}&longitude=${crd.longitude}&localityLanguage=en&key=bdc_f4ea7cfe87684687a15dfa49d332a95d`;
            fetch(geoApiUrl)
                .then((res) => res.json())
                .then((data) => {
                    setInitialLongitude(data.longitude);
                    setInitialLatidue(data.latitude);
                    setUserLocation(data.city);
                });
        }
        function error(err) {
            console.warn(
                `Access to your location denied ${err.code} - ${err.message}`
            );
        }

        navigator.geolocation.getCurrentPosition(success, error, options);
        getCurrentData(userLocation);
    }, [userLocation]);

    const submitCity = (e) => {
        const input = document.querySelector('.city-input');
        e.preventDefault();
        city !== '' && getCurrentData(city);
        input.style.height = 'auto';

        setCity('');

        setTimeout(() => {
            const days = document.querySelectorAll('.hide');
            days.forEach((item) => {
                item.classList.remove('hide');
            });
        }, 1500);
    };

    useEffect(() => {
        getForecastData(data.coord.lat, data.coord.lon);
    }, [data.coord.lat, data.coord.lon]);

    return (
        <>
            <Input cityName={getCity} submitCity={submitCity} />
            <Current currentData={data} />
            <Forecast
                forecastData={forecast}
                userLat={initialData.coord.lat}
                userLon={initialData.coord.lon}
            />
        </>
    );
};

export default App;
